<template>
  <div class="snackbar">
    <v-snackbar
    v-if="config.content !== this.$t('messages.save.defaultSuccess')"
      v-model="config.enabled"
      :timeout="config && config.content && config.content.includes('already initiated an application') ? -1 : config && config.content && config.content.includes('log in') ? -1 : config && config.title && config.title === this.$t('messages.unsavedChangesTitle') ? -1 : config.timeout"
      :color="config.color"
      :top="config.topPosition"
      :right="language !== '' ? false : config.rightPosition"
      :left="language!== '' ? true : config.leftPosition"
      :bottom="config.bottomPosition"
      :multi-line="true"
      rounded="pill"
      text
      outlined
    >
    <div :class="[`snackbar__content__${config.type.toLowerCase()}`]">
      <v-row no-gutters>
        <v-col cols="1">
            <div class="icon-class">
              <v-icon large :class="['material-icons-outlined', `icon-${config.type.toLowerCase()}`]">{{ config.icon
                }}</v-icon>
            </div>
          </v-col>
          <v-col cols="10" :class="config.type.toLowerCase() === 'success' ? 'snackbar__content__success-text' : ''">
            <v-row class="snackbar__content__title">
              <span v-if="config && config.content.includes('Kindly provide additional details')"> {{$t(`snackbar.additionalInformation`)}}</span>
              <span v-else-if="config && config.content.includes('Minimum')">
                <p>{{ config.content.split('.')[0] }}</p>
                <p class="snackbar__content__subtitles">{{ config.content.split('.')[1] }} </p>
              </span>
              <span v-else >{{ config.title }}</span>
            </v-row>
            <v-row v-if="config && !config.content.includes('Minimum')">
              <div v-for="(text, index) in config.content.split('\n')" :key="index" class="snackbar__content__subtitle">
                {{ text }}
              </div>
            </v-row>
          </v-col>
          <v-col cols="1">
            <v-btn icon color="white" x-small class="snackbarClose" @click="config.enabled = false">
              <BaseIcon name="close-small" size="md" :color="customCSS['grey']"/>
            </v-btn>
          </v-col>
      </v-row>
    </div>
      <v-flex v-if="config && config.content && config.content.includes('already initiated an application')" style="display: flex; justify-content: flex-end;" class="snackbar_button">
        <v-btn rounded small color="#694ED6" style="color:white; text-transform: none;" @click="resumeOnboarding">{{$t(`snackbar.resumeOnboarding`)}}</v-btn>
      </v-flex>
      <v-flex v-else-if="config && config.content && config.content.includes('log in')" style="display: flex; justify-content: flex-end;" class="snackbar_button">
        <v-btn rounded small color="#694ED6" style="color:white; text-transform: none;" class="text-none white--text" @click="logIn">{{$t(`snackbar.logIn`)}}</v-btn>
      </v-flex>
    </v-snackbar>
  </div>
</template>

<script>
import '@/styles/components/snackbar.scss';
import routeMixin from '@/_core/mixins/routeMixin.js';
import appSettings from '@/plugins/appSettings';
import * as colors from '@/_core/util/themeUtility';
import BaseIcon from '../common/BaseIcon.vue';

export default {
  name: 'RUISnackbar',
  mixins: [routeMixin],
  props: {
    config: {
      type: Object,
      default() {
        return {
          title: '',
          enabled: true,
          content: '',
          color: 'green',
          timeout: 4000,
          topPosition: true,
          rightPosition: true,
        };
      },
    },
  },
  components: {
    BaseIcon,
  },
  data() {
    return {
      customCSS: {},
    };
  },
  created() {
    this.customCSS = colors.colors;
    this.setColorThemes();
    const localeSelected = localStorage.getItem('localeSelected');
    this.language = localeSelected === 'ar' ? localeSelected : '';
    if (this.config.title !== undefined && this.config.title.includes('Success')) {
      this.config.enabled = false;
    }
  },
  methods: {
    setColorThemes() {
      document.documentElement.style.setProperty('--fontFamily', this.customCSS['formContent-formSubtitleFontFamily']);
    },
    resumeOnboarding() {
      const productType = this.getProductType;
      const productCode = this.getProductCode;
      const productTerm = this.getProductTerm;
      const applicationCode = 'fede';
      const customerOnboarding = 'resume';
      const timeOutUrl = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/' + applicationCode + '/' + productType + '/' + productCode + '/' + productTerm + '/' + customerOnboarding;
      window.location = timeOutUrl;
    },
    logIn() {
      const logIn = appSettings.dco.logIn;
      window.location.href = logIn;
    },
  },
};
</script>
